/**
 * The server's semantic tones, and the one place they become colours.
 *
 * The server decides WHICH tone, under its own thresholds in helpers.py; this
 * decides what a tone looks like. Unknown tones render plain. (2026-09-10)
 */
export type Tone = "plain" | "muted" | "warn" | "bad";

export function toneClass(tone: Tone): string {
  if (tone === "bad") return "text-red-400";
  if (tone === "warn") return "text-amber-400";
  if (tone === "muted") return "text-neutral-500";
  return "";
}
